import { Chip, type SxProps, Typography } from '@mui/material';
import React from 'react';
import { useIntl } from 'react-intl';

import type { ResourceSourceType } from 'generated/types';

interface RecordSourcePillProps {
  type?: ResourceSourceType;
  style?: SxProps;
}

export default function RecordSourcePill({
  style,
  type,
}: RecordSourcePillProps) {
  const { formatMessage } = useIntl();

  /*
  const MAP: Record<ResourceSourceType, StackedIconProps[][]> = {
    [ResourceSourceType.Device]: [[{ name: 'watch-fitness' }]],
    [ResourceSourceType.Emr]: [[{ name: 'file-export' }]],
    [ResourceSourceType.Network]: [[{ name: 'cloud-arrow-up' }]],
    [ResourceSourceType.Pdf]: [[{ name: 'file' }]],
    [ResourceSourceType.Scan]: [
      [
        { name: 'expand', size: '2xl' },
        { name: 'face-smile', size: '1x', transform: 'right-10' },
      ],
      [
        { name: 'expand', size: '2xl' },
        { name: 'person', size: 'lg', transform: 'right-5' },
      ],
    ],
    [ResourceSourceType.Self]: [[{ name: 'hospital-user' }]],
  };
  */

  if (!type) {
    return null;
  }
  return (
    <Chip
      color="primary"
      // icon={
      //   <Stack direction="row" spacing={1}>
      //     {MAP[type].map((a, index) => (
      //       <StackedIcon
      //         key={`stacked-icon-${index}`}
      //         icons={a.map((i) => ({
      //           key: i.name,
      //           size: 'xl',
      //           type: 'fas',
      //           ...i,
      //         }))}
      //       />
      //     ))}
      //   </Stack>
      // }
      label={
        <Typography
          color="text.secondary"
          variant="body2"
          sx={{ textTransform: 'capitalize' }}
        >
          {formatMessage({ id: `recordSourcePill.${type}` })}
        </Typography>
      }
      sx={{
        borderWidth: 1.5,
        backgroundColor: 'background.paper',
        ...style,
      }}
      variant="outlined"
    />
  );
}
